import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import createInfo from "../../../Announcements/Announcement.module.css";
import Select from "react-select";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import moment from "moment";
import DatePickerSample from "../../../../DatePicker";
import Loader from "../../../../Loader";
import { AxiosInstance } from "../../../../../../axios";
export default function CreateRewardPoints() {
  const { id } = useParams();
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;

  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user.user_id;
    }
  } else {
    console.log("User Id not available in session storage");
  }
  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);
  const navigate = useNavigate();
  const [ccategory, setCcategory] = useState([]);
  const [initialfields, setInitialfields] = useState({
    Description: "",
    start_date: "",
    end_date: "",
    point_per_hundred: "",
    amount_per_point: "",
    is_reward_use: ""
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState({});

  useEffect(() => {
    if (id) {
      AxiosInstance.post(`api/book/reward_view`, { id: id })
        .then((res) => {
          setIsLoading(true);
          if (res.data.status === true) {
            console.log(res.data.data, "5678765456");

            const { validity_date } = res.data.data;
            // Split the validity_date
            const [fromDate, toDate] = validity_date
              .split(" - ")
              .map((date) => date.trim());
            setIsLoading(false);
            setInitialfields({
              point_per_hundred: res.data.data.point_per_hundred,
              amount_per_point: res.data.data.amount_per_point,
              Description: res.data.data.description,
              from_date: fromDate,
              end_date: toDate,
              is_reward_use: res.data.data.is_reward_use

            });
          } else {
            setIsLoading(false);
            toast.error(res.data.message);
          }
        })
        .catch((error) => {
          setIsLoading(false);
          return error;
        });
    }
  }, [id]);

  const handleChangeSelectDropdown = (option, dname) => {
    if (dname === "Category") {
      setInitialfields((prevState) => ({
        ...prevState,
        Category: option.label,
        Category_ID: option.value,
      }));
      setError({
        ...error,
        [dname]: "",
      });
    }
  };

  const handleDateChange = (date, fieldName) => {
    const formattedDate = date ? moment(date).format("DD/MM/YYYY") : "";
    if (fieldName === "from_date") {
      const selectedStart = moment(formattedDate, "DD/MM/YYYY");
      const currentEnd = moment(initialfields.end_date, "DD/MM/YYYY");
      const shouldResetEndDate = currentEnd.isValid() && currentEnd.isBefore(selectedStart);
      setInitialfields({
        ...initialfields,
        from_date: formattedDate,
        end_date: shouldResetEndDate ? "" : initialfields.end_date,
      });
      setError({
        ...error,
        from_date: "",
        end_date: shouldResetEndDate ? "" : error.end_date,
      });
    } else {
      setInitialfields({
        ...initialfields,
        [fieldName]: formattedDate,
      });
      setError({
        ...error,
        [fieldName]: "",
      });
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    setInitialfields((prevFields) => ({
      ...prevFields,
      [name]: value,
    }));
    setError({
      ...error,
      [name]: "",
    });
  };
  //  refx
  const description = useRef(null);
  const point_per_hundred = useRef(null);
  const amount_per_point = useRef(null);
  const from_date_ref = useRef(null);
  const end_date_ref = useRef(null);

  function isFloat(x) {
    return !!(x % 1);
  }
  // Validation function
  const validateFields = (data) => {
    const errors = {};

    if (!data.amount_per_point) {
      errors.amount_per_point = "Please enter an amount per point";
    } else if (
      data.amount_per_point &&
      parseInt(data.amount_per_point) <= 0 &&
      !isFloat(data.amount_per_point)
    ) {
      errors.amount_per_point = "Please enter an amount per point";
    } else if (
      data.amount_per_point &&
      isFloat(data.amount_per_point) &&
      !/^\d+\.\d{1,3}$|^\d+$/.test(data.amount_per_point)
    ) {
      errors.amount_per_point =
        "Please enter a valid amount per point with up to 3 decimal precision";
    }

    if (!data.point_per_hundred) {
      errors.point_per_hundred = "Please enter a point per hundred";
    } else if (
      data.point_per_hundred &&
      (/^0(?!$)/.test(data.point_per_hundred) ||
        parseInt(data.point_per_hundred) <= 0)
    ) {
      errors.point_per_hundred =
        "Points per hundred must be a positive number and not start with negative";
    }

    if (!data.Description || data.Description.trim() === "") {
      errors.Description = "Please enter a description";
    }

    if (!data.from_date) {
      errors.from_date = "Please select a validity start date";
    }

    if (!data.end_date) {
      errors.end_date = "Please select a validity end date";
    }

    if (data.from_date && data.end_date) {
      const from_date = moment(data.from_date, "DD/MM/YYYY");
      const end_date = moment(data.end_date, "DD/MM/YYYY");

      // if (end_date.isSameOrBefore(from_date)) {
      //   errors.end_date = "End date must be after the start date";
      // }
    }

    return errors;
  };

  // focus the error fields in comment section
  const validateFocusCommentSection = (COMSECFO) => {
    if (!COMSECFO.Description) {
      description.current.focus();
    } else if (!COMSECFO.point_per_hundred) {
      point_per_hundred.current.focus();
    } else if (!COMSECFO.amount_per_point) {
      amount_per_point.current.focus();
    } else if (!COMSECFO.from_date) {
      from_date_ref.current.focus();
    } else if (!COMSECFO.end_date) {
      end_date_ref.current.focus();
    }
  };

  const handleSubmit = () => {
    const errors = validateFields(initialfields);
    if (Object.keys(errors).length === 0) {
      try {
        if (id) {
          // If an id is provided, update the data
          const announcementData = {
            id: id,
            description: initialfields.Description,
            point_per_hundred: initialfields.point_per_hundred,
            amount_per_point: initialfields.amount_per_point,
            from_date: moment(initialfields.from_date, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ),
            end_date: moment(initialfields.end_date, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ),
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
          };

          AxiosInstance.post(`api/book/createrewards`, announcementData)
            .then((res) => {
              if (res.data.status) {
                toast.success(res.data.message);
                navigate("/RewardPoints");
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        } else {
          // If no id is provided, add the new data
          const createAnnouncementData = {
            id: "",
            description: initialfields.Description,
            point_per_hundred: initialfields.point_per_hundred,
            amount_per_point: initialfields.amount_per_point,
            from_date: moment(initialfields.from_date, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ),
            end_date: moment(initialfields.end_date, "DD/MM/YYYY").format(
              "YYYY-MM-DD"
            ),
            created_dt: moment().format("YYYY-MM-DD HH:mm:ss"),
            created_by: userid,
          };

          AxiosInstance.post(`api/book/createrewards`, createAnnouncementData)
            .then((res) => {
              // console.log(res);
              if (res.data.status) {
                toast.success(res.data.message);
                navigate("/RewardPoints");
              } else {
                toast.error(res.data.message);
              }
            })
            .catch((error) => {
              return error;
            });
        }
      } catch (error) {
        console.log(error);
      }
    } else {
      setError(errors);
    }
  };

  const navigateToPreviousScreen = () => {
    navigate(-1);
  };

  return isLoading ? (
    <div
      className="loaderApi"
      style={{
        display: isLoading ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        zIndex: 999,
      }}
    >
      {isLoading && <Loader />}
    </div>
  ) : (
    <div className={`${createInfo.CourseInfoSec} BathHeader global_container`}>
      <div className="row">
        <div className="col-md-6 col-12">
          <h2 className="TitleHeader">
            {id ? "Edit Reward Point" : "Create New Reward Point"}
          </h2>
        </div>
        <div className="col-md-6 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/RewardPoints"}
                onClick={id ? navigateToPreviousScreen : () => { }}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to Reward Points" : "Back to Reward Points"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Reward Point
              </Link>
            </li>
          </ul>
        </div>
        <div className="row m-0 mb-3">
          <fieldset className="mt-3">
            <legend className="w-auto">Reward Point Details</legend>
            <form className="row g-3">
              <div className="col-md-6">
                <label
                  htmlFor="Description"
                  className="form-label confirm_value"
                >
                  Description
                </label>
                <input
                  ref={description}
                  className={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                  placeholder="Enter a description"
                  value={initialfields.Description}
                  name="Description"
                  maxLength={500}
                  disabled={initialfields.is_reward_use == 1}
                  onChange={handleChange}
                />
                {error.Description && (
                  <small className={createInfo.errors}>
                    {error.Description}
                  </small>
                )}
              </div>

              <div className="col-md-6">
                <label
                  htmlFor="point_per_hundred"
                  className="form-label confirm_value"
                >
                  Points per ₹100
                </label>
                <input
                  type="number"
                  ref={point_per_hundred}
                  className={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                  placeholder="Enter a point per hundred"
                  max={5}
                  value={
                    initialfields.point_per_hundred <= 0
                      ? ""
                      : parseInt(initialfields.point_per_hundred)
                  }
                  disabled={initialfields.is_reward_use == 1}
                  name="point_per_hundred"
                  onChange={handleChange}
                />
                {error.point_per_hundred && (
                  <small className={createInfo.errors}>
                    {error.point_per_hundred}
                  </small>
                )}
              </div>

              <div className="col-md-6">
                <label
                  htmlFor="amount_per_point"
                  className="form-label confirm_value"
                >
                  Amount Per Point
                </label>
                <input
                  ref={amount_per_point}
                  type="number"
                  className={`desc_input_text w-100 rounded-2 input-font-size-sm`}
                  placeholder="Enter an amount per point"
                  value={
                    initialfields.amount_per_point < 0
                      ? ""
                      : initialfields.amount_per_point
                  }
                  disabled={initialfields.is_reward_use == 1}
                  name="amount_per_point"
                  onChange={handleChange}
                />
                {error.amount_per_point && (
                  <small className={createInfo.errors}>
                    {error.amount_per_point}
                  </small>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="from_date" className="form-label confirm_value">
                  Validity Start Date
                </label>
                <DatePickerSample
                  disabledProperty={initialfields.is_reward_use == 1}

                  classDisabled={initialfields.is_reward_use == 1 ? "disabled_btn" : ""}
                  txtAdMDob={from_date_ref}
                  handleChange={(date) => initialfields.is_reward_use == 1 ? {} : handleDateChange(date, "from_date")}
                  fieldInput={initialfields.from_date}
                  minDate={new Date(new Date().setDate(new Date().getDate()))} // Minimum date is tomorrow
                />
                {error.from_date && (
                  <small className={createInfo.errors}>{error.from_date}</small>
                )}
              </div>

              <div className="col-md-6">
                <label htmlFor="end_date" className="form-label confirm_value">
                  Validity End Date
                </label>
                <DatePickerSample
                  txtAdMDob={end_date_ref}
                  handleChange={(date) => handleDateChange(date, "end_date")}
                  fieldInput={initialfields.end_date}
                  minDate={
                    initialfields.from_date
                      ? moment(initialfields.from_date, "DD/MM/YYYY").toDate()
                      : new Date(
                        new Date().setDate(
                          new Date().getDate() + initialfields.from_date
                        )
                      )
                  } // Minimum date is the selected start date
                />
                {error.end_date && (
                  <small className={createInfo.errors}>{error.end_date}</small>
                )}
              </div>
            </form>
          </fieldset>
        </div>
        {/*  */}
        <div className="col-md-12 col-12 ListBtn">
          <ul className="List-Button">
            <li className="ListBtnItems">
              <Link
                to={id ? "javascript:void(0)" : "/RewardPoints"}
                onClick={id ? navigateToPreviousScreen : () => { }}
                className="secondaryButton "
                variant="secondary"
              >
                {id ? "Back to Reward Points" : "Back to Reward Points"}
              </Link>
            </li>
            <li className="ListBtnItems">
              <Link
                to="javascript:void(0)"
                onClick={handleSubmit}
                className="primaryButton text-center "
                variant="primary"
              >
                Save Reward Point
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
